/* Config */
var phoneBreakpoint = 500;
var tabletBreakpoint = 768;

$(document).ready(function () {
    deviceCheck();
    components();
    colorboxModal();
    imageEffects();
    hiddenFields();
});

$(window).on("load", function () {
    var tabIndex = window.localStorage.getItem('tabIndex')
    $("[tabindex=" + tabIndex + "]").focus()
});


$(window).on('resize', function () {
    changeEvents();
});
$(window).on('orientationchange', function () {
    changeEvents();
});

function changeEvents() {
    deviceCheck();
}

function components() {
    responsiveVideoEmbed();
    ////responsiveTables();
    responsiveTabs();
    accordion();

}
function deviceCheck() {
    if ($(window).width() < tabletBreakpoint && $(window).width() >= phoneBreakpoint) {
        isMobile = true;
        isTablet = true;
        isPhone = false;
    }
    else if ($(window).width() < phoneBreakpoint) {
        isMobile = true;
        isPhone = true;
        isTablet = false;
    }
    else {
        isMobile = false;
        isTablet = false;
        isPhone = false;
    }
    if ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) {
        isTouch = true;
    }
    else {
        isTouch = false;
    }
}

function responsiveVideoEmbed() {
    // make each embedded YouTube or Vimeo iframes responsive automatically
    $('iframe').each(function () {
        var thisSrc = $(this).attr('src')
        if (thisSrc.indexOf('youtu') != -1 || thisSrc.indexOf('youtube') != -1 || thisSrc.indexOf('vimeo') != -1) {
            $(this).wrap('<div class="video-wrapper"></div>');
        }
    });
}

function responsiveTables() {
    //initialise responsive tables
    $('table').footable({
        breakpoints: {
            phone: phoneBreakpoint,
            tablet: tabletBreakpoint
        }
    });
}

function responsiveTabs() {
    // Responsive tabs to mobile accordions init
    RESPONSIVEUI.responsiveTabs();
}

function accordion() {
    // initialise each accordion
    $('.accordion').each(function () {
        $(this).addClass('enabled');
        var hasActiveSection = $(this).find('.accordion-title.active').length > 0;
        if (hasActiveSection) {
            $(this).find('.accordion-title.active').next('.accordion-content').addClass('active').removeClass('inactive').siblings('.accordion-content').removeClass('active').addClass('inactive');
        }
        else {
            $(this).find('.accordion-title:first-child').addClass('active').next('.accordion-content').addClass('active').removeClass('inactive').siblings('.accordion-content').removeClass('active').addClass('inactive');
        }
    });
    // accordion heading click event
    $('.accordion-title').click(function () {
        var independentAccordion = $(this).parents('.accordion').attr('data-independent') == 'true';
        var isActive = $(this).hasClass('active');
        if (!isActive) {

            $(this).next('.accordion-content').addClass('active').removeClass('.inactive');
            $(this).addClass('active');

        }
        else {
            $(this).next('.accordion-content').removeClass('active').removeClass('active').addClass('inactive');
            $(this).removeClass('active');
        }
        return false;
    });
}

function colorboxModal() {
    $(".cbox").colorbox({ iframe: true, scrolling: true, width: "80%", height: "80%" });
}

function imageEffects() {
    $("img[data-src-popout]").click(function () {
        $.colorbox({ iframe: true, href: "/images/colorbox/overlay.png", width: "80%", height: "80%" });
    });
    $("img[data-src-hover]").hover(
        function () {
            var src = $(this).attr('data-src-hover');
            $(this).attr('data-src-hover', $(this).attr('src'));
            $(this).attr('src', src);
        }
    );
}

function hiddenFields() {
    $('.hiddenfield, .hiddenfields').hide();
}

function rentCollectorOnly() {

    var valid = false;
    $("#ctl00_PageContent_fdInterestType").find(":checkbox").each(function () {
        if ($(this).is(":checked")) {
            if ($(this).val() != 5) {
                valid = true;
            }
        }
    });

    return valid;
}

function showInterestError() {

    var rentCollectorSelected = false;
    $("#ctl00_PageContent_fdInterestType").find(":checkbox").each(function () {
        if ($(this).is(":checked") && ($(this).val() == 5)) {
            rentCollectorSelected = true;
        }
    });

    if (rentCollectorSelected) {
        $('#ctl00_PageContent_lbcInterestType_Validator').text('You cannot solely select Rent Collector.');
    } else {
        $('#ctl00_PageContent_lbcInterestType_Validator').text('You must select at least one interest type.');
    }

    $('#ctl00_PageContent_lbcInterestType_Validator').css('display', 'inline');
}

function selectInterestType(interestTypeList) {
    if (interestTypeList.is(':checked')) {
        if (interestTypeList.val() == 'Other') {
            $('.hiddenfields-interest-other').slideDown();
            $('#ctl00_PageContent_fdInterestTypeOther').val('');
        }
    } else {
        // checkbox is unchecked
        if (interestTypeList.val() == 'Other') {
            $('.hiddenfields-interest-other').slideUp();
            $('#ctl00_PageContent_fdInterestTypeOther').val('aaa');
        }
    }
}

function StoreScrollPosition(sender, args) {
    $('#fdScrollPosition').val($(window).scrollTop());
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};


function focusNextElement() {

    if (document.activeElement) {
        window.localStorage.setItem('tabIndex', document.activeElement.tabIndex);
        ;
    }
}


window.addEventListener('keydown', function (e) {
    if (e.key == 'Tab') {
        focusNextElement();
    }
}, true);

$(function () {
    var cookieBar = {};

    cookieBar.bindBtn = function () {
        var btn = cookieBar.container.find("#CookiePolicyAccept");

        btn.off('click.cookieok').on('click.cookieok', function () {
            cookieBar.hide();
        });
    };

    cookieBar.show = function () {
        cookieBar.container.removeClass(cookieBar.containerHiddenClass);
    };

    cookieBar.hide = function () {
        cookieBar.container.addClass(cookieBar.containerHiddenClass);
    };

    cookieBar.accepted = function () {
        setCookie(cookieBar.cname, true, 1825);
    };

    cookieBar.init = function () {
        cookieBar.cname = 'rtCookie';
        cookieBar.autoSet = true;

        if (!getCookie(cookieBar.cname)) {
            cookieBar.container = $('#CookiePolicy');
            cookieBar.containerHiddenClass = 'c-cookie-bar--hidden';

            cookieBar.show();
            cookieBar.bindBtn();

            if (cookieBar.autoSet) {
                cookieBar.accepted();
            };
        };
    }();
});